forceMenuDropDown = function () {

        $('.has-submenu').addClass('active');
        $('.submenu').css('display', 'block');

}

changeLink = function() {

    $("#section-1527182970162 .button").attr("href", "/pages/collections");
    $("#block-1527179450415-0 .button").attr("href", "/pages/engagement-collection");

}

colorText = function() {

  $('#wedding-bands h1').text("YOU ARE MY UNIVERSE BANDS");

}

historySlider = function() {

  $('.owl-carousel').owlCarousel({
    loop:true,
    nav:true,
    navText : ["",""],
    rewind:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
  })

}

footerLinks = function() {

    $('ul.footer-links li:nth-child(6) a').attr("target", "_blank");
    $('ul.footer-links li:nth-child(7) a').attr("target", "_blank");

}

$(document).ready(forceMenuDropDown);
$(document).ready(changeLink);
$(document).ready(colorText);
$(document).ready(historySlider);
$(document).ready(footerLinks);